module.exports = __webpack_public_path__ + "img/loan.fd69c004.png";